(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined"
    ? (module.exports = factory())
    : typeof define === "function" && define.amd
    ? define(factory)
    : ((global = global || self),
      ((global.FullCalendarLocales = global.FullCalendarLocales || {}),
      (global.FullCalendarLocales.nl = factory())));
})(this, function() {
  "use strict";

  return {
    groupPeriods: function(periods) {
      let groupedPeriods = [];

      // while
      while (periods.length > 0) {
        let startDate = periods[0].startDate;
        let stopDate = periods[0].stopDate;

        let group = [];

        let foundOne = true;
        while (foundOne === true) {
          foundOne = false;
          if (periods.length === 0) {
            break;
          }
          for (let i in periods) {
            if (
              periods[i].startDate !== startDate ||
              periods[i].stopDate !== stopDate
            ) {
              continue;
            }

            group.push(periods[i]);
            periods.splice(i, 1);

            foundOne = true;
          }
        }

        groupedPeriods.push({
          startDate: startDate,
          stopDate: stopDate,
          dayPeriods: group
        });

        group = [];
      }

      return groupedPeriods;
    },
    reformatLoadedShiftPeriods: function(periods) {
      // Add (sub) periods in each period
      for (var i in periods) {
        periods[i]["periods"] = [];
      }

      periods.sort(function(a, b) {
        if (a.startDate < b.startDate || a.startDate === null) {
          return -1;
        }
        if (a.startDate > b.startDate || b.startDate === null) {
          return 1;
        }
        return 0;
      });

      // find direct parents
      var foundParentIds = {};
      for (var childIndex in periods) {
        foundParentIds[periods[childIndex].id] = [];
        for (var parentIndex in periods) {
          if (
            (periods[parentIndex].startDate < periods[childIndex].startDate ||
              (periods[parentIndex].startDate === null &&
                periods[childIndex].startDate !== null)) &&
            (periods[parentIndex].stopDate > periods[childIndex].stopDate ||
              (periods[parentIndex].stopDate === null &&
                periods[childIndex].stopDate !== null))
          ) {
            foundParentIds[periods[childIndex].id].push(
              periods[parentIndex].id
            );
          }
        }
      }

      // Remove childs without parents, which are basicly the top parents
      for (childIndex in foundParentIds) {
        if (foundParentIds[childIndex].length === 0) {
          delete foundParentIds[childIndex];
        }
      }

      // Deduct direct parent from data
      // first find childs with multiple parents
      // Maybe should loop multiple times when not everyting is resolved?
      for (childIndex in foundParentIds) {
        if (foundParentIds[childIndex].length < 2) {
          continue;
        }

        // Loop though parent keys and try to find them
        for (var childParentIndex in foundParentIds[childIndex]) {
          for (var parentIndex in foundParentIds) {
            if (
              foundParentIds[childIndex][childParentIndex] === parentIndex &&
              foundParentIds[parentIndex].length === 1
            ) {
              // Found parent with single parent
              for (var childRemoveIndex in foundParentIds) {
                if (
                  !foundParentIds[childRemoveIndex].includes(parentIndex) ||
                  !foundParentIds[childRemoveIndex].includes(
                    foundParentIds[parentIndex][0]
                  )
                ) {
                  continue;
                }

                var index = foundParentIds[childRemoveIndex].indexOf(
                  foundParentIds[parentIndex][0]
                );
                if (index !== -1)
                  foundParentIds[childRemoveIndex].splice(index, 1);
              }
            }
          }
        }
      }

      // loop though child & parent relationships and find the childs that aren't parents and move them to their parents data
      while (Object.keys(foundParentIds).length > 0) {
        for (childIndex in foundParentIds) {
          var found = false;
          for (var otherChildIndex in foundParentIds) {
            if (foundParentIds[otherChildIndex].includes(childIndex)) {
              found = true;
              break;
            }
          }

          if (found) {
            continue;
          }

          // Move child to parent
          for (var childPeriodsIndex in periods) {
            if (periods[childPeriodsIndex].id === childIndex) {
              break;
            }
          }
          for (var parentPeriodsIndex in periods) {
            if (
              periods[parentPeriodsIndex].id === foundParentIds[childIndex][0]
            ) {
              break;
            }
          }

          periods[parentPeriodsIndex].periods.push(periods[childPeriodsIndex]);
          delete periods[childPeriodsIndex];
          delete foundParentIds[childIndex];
          // periods = periods.slice(0, periods.length - 1);
          // foundParentIds = foundParentIds.slice(0, foundParentIds.length - 1);

          break;
        }
      }

      var newPeriods = [];
      for (i in periods) {
        newPeriods.push(periods[i]);
      }

      return newPeriods;
    },
    getDriverAvailabilityByDateRouteShift: function(
      periods,
      date,
      routeId,
      shiftId
    ) {
      var period = {};
      var weekOddEven = new Date(date).getWeek() % 2;
      var dayOfTheWeek = new Date(date).getDay();

      for (var i in periods) {
        if (
          periods[i].route_ids.indexOf(routeId) !== -1 &&
          periods[i].shift_ids.indexOf(shiftId) !== -1 &&
          parseInt(periods[i].weekOddEven) === weekOddEven &&
          parseInt(periods[i].dayOfTheWeek) === dayOfTheWeek
        ) {
          if (
            (Object.keys(period).length === 0 &&
              (periods[i].startDate === null || periods[i].startDate <= date) &&
              (periods[i].stopDate === null || periods[i].stopDate >= date)) ||
            ((period.startDate === null ||
              periods[i].startDate > period.startDate) &&
              periods[i].startDate <= date &&
              (period.stopDate === null ||
                periods[i].stopDate < period.stopDate) &&
              periods[i].stopDate >= date)
          ) {
            period = periods[i];
          }
        }
      }

      if (Object.keys(period).length === 0) {
        return 9;
      }

      return parseInt(period.availability);
    }
  };
});
